import styled from 'styled-components';
import {scrollbar} from '../../../globalVariables/GlobalVariables';
import {dFlexColumn, dFlexCenter} from '../../../globalVariables/GlobalFlex';
import TickchakLogo from '../../../assets/icons/TickchakLogo';
import {statusStripHeight} from '../StatusLabel/StatusLabel.css';

/* The card is built at a fixed native size and scaled as one unit (zoom), so text and chrome
   shrink together and never overflow on small screens. --card-scale is set on the carousel. */
export const cardScaler = styled.div`
    width: 330px;
    height: 690px;
    flex: none;
    transform-origin: top center;
    transform: scale(var(--card-scale, 1));
`;

export const cardInner = styled.div`
    width: 100%;
    height: 100%;
    ${dFlexColumn};
    background: var(--color-bg-base);
    color: var(--color-text-default);
    border-radius: var(--border-radius-border-radius-2xl);
    overflow: clip;
`;

export const top = styled.div`
    flex: none;
    min-height: ${statusStripHeight};
    border-bottom: 1px solid var(--color-border-subtle);
`;

export const middle = styled.div`
    flex: 1;
    min-height: 0;
    ${scrollbar};
`;

export const footer = styled.div`
    flex: none;
    ${dFlexCenter};
    gap: var(--space-sm);
    padding: var(--space-sm) var(--space-lg);
    border-top: 1px solid var(--color-border-subtle);

    &.with-link {
        justify-content: space-between;
    }
`;

export const logo = styled(TickchakLogo)`
    height: 30px;
    width: auto;
    flex: none;
    display: block;
`;

export const terms = styled.a`
    font-size: var(--font-size-caption);
    color: var(--color-text-default);
    text-decoration: underline;
`;
